import { queryOptions, useQuery } from '@tanstack/react-query';

import { ClusterCleanupResponse } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const EXTERNAL_CLUSTER_CLEANUP_QUERY_KEY = 'external-cluster-cleanup';
const getOffboardingScriptQueryKey = (params: { id: string }) =>
  [EXTERNAL_CLUSTER_CLEANUP_QUERY_KEY, params.id] as const;

const getOffboardingScriptQueryOptions = ({ id }: { id: string }) =>
  queryOptions({
    queryKey: getOffboardingScriptQueryKey({ id }),
    queryFn: async () => {
      const { data } = await apiClient.clusters.getOffboardingScript({
        clusterId: id,
      });
      return data.script;
    },
    enabled: !!id,
  });

type UseOffboardingScriptQuery = {
  isLoading: boolean;
  script?: ClusterCleanupResponse['script'];
  error: unknown;
  refetch: () => void;
};

export const useOffboardingScriptQuery = (
  id: string
): UseOffboardingScriptQuery => {
  const {
    isLoading,
    data: script,
    error,
    refetch,
  } = useQuery(getOffboardingScriptQueryOptions({ id }));

  return {
    isLoading,
    script,
    error,
    refetch,
  };
};
